import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

interface ExportFile {
  key: string;
  size: number;
  uploaded: string;
  metadata?: Record<string, string>;
}

export function useExports(prefix?: string) {
  const params = prefix ? `?prefix=${prefix}` : '';
  return useQuery({
    queryKey: ['exports', prefix],
    queryFn: () => api.get<ExportFile[]>(`/exports${params}`).then((r) => r.data),
  });
}
